import { t } from 'c-3po';
import { BESIDA_ROLE_COMPANY } from '@evo/chat-core';

import { Config } from './../../core/config';
import * as c from './../constants';

export function validateCountryPrice(price, currency) {
    const { DEFAULT_CURRENCY_TEXT, IS_BEL_PROM, IS_KZ_PROM } = Config.data.appState;

    if (!(currency && price) || (
        (IS_BEL_PROM || IS_KZ_PROM) && currency !== DEFAULT_CURRENCY_TEXT)) return t`товар без цены`;
    return `${price} ${currency}`;
}

export function getCompanyManagersId(users) {
    if (!users) return [];

    const managers = [];

    Object.keys(users).forEach((key) => {
        if (users[key].role === BESIDA_ROLE_COMPANY) managers.push(users[key].id)
    });

    return managers;
}

export function getProductPortalUrl(id) {
    const { PORTAL_DOMAIN } = Config.data.appState;

    return `${PORTAL_DOMAIN}/p${id}-product.html`;
}

export function getCreateOrderCabinetUrl(userId, productId, isNewCabinet, roomIdent, userTracking) {
    const { DEFAULT_ORIGIN } = Config.data.appState;

    return isNewCabinet
        ? (
        `${DEFAULT_ORIGIN}/cms/order/create?product_id=${productId}&room_order_ident=${roomIdent}&` +
             `user_id=${userId}&created_in_chat=true&user_tracking=${userTracking}`)
        : (
        `${DEFAULT_ORIGIN}/cabinet/order_v2/create?product_id=${productId}&` +
            `room_order_ident=${roomIdent}&user_id=${userId}&` +
            `created_in_chat=true&user_tracking=${userTracking}#client`);
}

export function getClientEditUrl(userId, isNewCabinet) {
    const { DEFAULT_ORIGIN } = Config.data.appState;

    return isNewCabinet
        ? `${DEFAULT_ORIGIN}/cms/client/user/${userId}`
        : `${DEFAULT_ORIGIN}/cabinet/company_clients/edit_user/${userId}`;
}

export function getC2CUserUrl(userId) {
    const { DEFAULT_ORIGIN } = Config.data.appState;
    return `${DEFAULT_ORIGIN}/classified/profile/${userId}`;
}

export function getAnalcsSocialActName(socialName) {
    switch (socialName) {
        case 'facebook':
            return c.ANALCS_ACTION_REGISTER_FB;
        case 'vkontakte':
            return c.ANALCS_ACTION_REGISTER_VK;
        case 'odnoklassniki':
            return c.ANALCS_ACTION_REGISTER_OD;
        case 'google':
            return c.ANALCS_ACTION_REGISTER_GM;
        default:
            return 'error';
    }
}

export function makeOrderLink(orderId, chatLocation, isNewCabinet) {
    const { DEFAULT_ORIGIN } = Config.data.appState;

    if (chatLocation === c.INIT_POSITION_CABINET) {
        return isNewCabinet ? `${DEFAULT_ORIGIN}/cms/order/edit/${orderId}` : (
            `${DEFAULT_ORIGIN}/cabinet/order_v2/edit/${orderId}`);
    }
    return `${DEFAULT_ORIGIN}/cabinet/user/order/view/${orderId}`;
}

export function getResponseMedianText(responseMedian) {
    const inMinutes = responseMedian / 60;
    if (!inMinutes) {
        return null;
    } else if (inMinutes < 5) {
        return t`Отвечает мгновенно`;
    } else if (inMinutes < 15) {
        return t`Отвечает в течение 15 мин`;
    } else if (inMinutes < 30) {
        return t`Отвечает в течение 30 мин`;
    } else if (inMinutes < 60) {
        return t`Отвечает в течение 1 ч`;
    }
    return t`Отвечает не регулярно`;
}
